import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Container, PageHeader } from "@/components/shared";
import PremiumHint from "@/components/PremiumHint";
import { MessageSquare, Search, Sparkles, Swords, Clock, CalendarCheck, Star, Trophy } from "lucide-react";

export default function Dashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/stats/me").then(({ data }) => setStats(data)).catch(() => {}); }, []);

  const fmtTime = (min) => {
    if (!min) return "0 min";
    const h = Math.floor(min / 60);
    const m = min % 60;
    return h ? `${h} h ${m ? m + " min" : ""}`.trim() : `${m} min`;
  };

  const CARDS = stats ? [
    { label: "Réponses générées", value: stats.replies, icon: MessageSquare },
    { label: "Analyses effectuées", value: stats.analyses, icon: Search },
    { label: "Scripts créés", value: stats.content, icon: Sparkles },
    { label: "Débats réalisés", value: stats.debates, icon: Swords },
    { label: "Temps gagné", value: fmtTime(stats.time_saved_minutes), icon: Clock, highlight: true },
    { label: "Jours d'utilisation", value: stats.days_active, icon: CalendarCheck },
    { label: "Favoris", value: stats.saved, icon: Star },
    { label: "Points", value: stats.points, icon: Trophy },
  ] : [];

  return (
    <Container className="max-w-5xl">
      <PageHeader eyebrow="Votre progression" title={`Bonjour ${user?.name?.split(" ")[0] || ""}`}
        subtitle="Suivez votre activité et le temps que BIZARRE AI vous fait gagner." />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {CARDS.map((c, i) => {
          const Icon = c.icon;
          return (
            <motion.div key={c.label} data-testid={`dash-${i}`}
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.05, duration: 0.4 }}
              className={`rounded-2xl p-5 border ${c.highlight ? "border-gold/40 bg-gradient-to-b from-[#161206] to-[#050505]" : "border-white/10 bg-[#0A0A0A]"}`}>
              <Icon size={20} className={c.highlight ? "text-gold" : "text-white/60"} strokeWidth={1.5} />
              <div className={`font-display text-3xl mt-3 ${c.highlight ? "gold-text" : ""}`}>{c.value}</div>
              <div className="text-white/40 text-xs mt-1">{c.label}</div>
            </motion.div>
          );
        })}
      </div>

      <PremiumHint text="Débloquez des limites très élevées et gagnez encore plus de temps avec Premium." />
    </Container>
  );
}
